/**
 * The library: the account's playlists, then the demo crate.
 *
 * The two halves are independent on purpose. The crate is in memory and
 * renders at once; the YouTube half sits inside its own boundaries, so a slow
 * account only delays its own rows and a failed one costs only the playlists
 * — liked music is always reachable, and the crate below never notices.
 */

import { useQuery } from '@tanstack/solid-query';
import { type Component, Errored, Loading, Show } from 'solid-js';
import { playlistsQuery } from '../../app/queries.ts';
import { demoPlaylists } from '../../data/demo-library.ts';
import { LIKED_PLAYLIST } from '../../data/youtube-shape.ts';
import { account } from '../../state/library.ts';
import { PlaylistList } from './PlaylistList.tsx';
import { Spinner } from './SheetStates.tsx';

const YOUTUBE = 'YouTube Music';

const YouTubePlaylists: Component = () => {
  const query = useQuery(() => playlistsQuery());
  return <PlaylistList title={YOUTUBE} items={[LIKED_PLAYLIST, ...query.data]} />;
};

export const LibraryPanel: Component = () => (
  <>
    <Show when={account().signedIn}>
      <Loading fallback={<Spinner />}>
        <Errored fallback={<PlaylistList title={YOUTUBE} items={[LIKED_PLAYLIST]} />}>
          <YouTubePlaylists />
        </Errored>
      </Loading>
    </Show>

    <PlaylistList
      title={account().signedIn ? 'Demo crate' : 'Demo crate — no account needed'}
      items={demoPlaylists}
    />
  </>
);
